import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ERTUserService } from "../../../services/ert-user/ert-user.service";
import { ERTUser } from "../../../interfaces/ert-user/ert-user";
import { Router } from "@angular/router";
import { LoggedUserService } from "../../../services/common/logged-user.service";
import { PicklistService } from "../../../services/administration/picklist/picklist.service";
import { IPicklistValuesData } from "../../../interfaces/administration/picklistValuesData";
import { forkJoin } from "rxjs";
@Component({
  selector: "app-ert-new-user",
  templateUrl: "./ert-new-user.component.html",
  styleUrl: "./ert-new-user.component.css",
})
export class ErtNewUserComponent implements OnInit {
  userForm: FormGroup;
  divisions: any[] = [];
  units: any[] = [];
  validationMessages: string[] = [];
  selectedUnit: IPicklistValuesData;
  selectedDivision: IPicklistValuesData;
  unitFieldId: number = 0;
  divisionFieldId: number = 0;
  isLoading: boolean = false;
  constructor(
    private fb: FormBuilder,
    private userService: ERTUserService,
    private loggedUserService: LoggedUserService,
    private pickListsService: PicklistService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLoading = true;
    forkJoin({
      unitFieldId: this.pickListsService.getFieldIdByName("Unit"),
      divisionFieldId: this.pickListsService.getFieldIdByName("Division"),
      divisions: this.pickListsService.getPicklistValues(this.divisionFieldId),
      facility: this.loggedUserService.getLoggedUserFacilityName(),
    }).subscribe(({ unitFieldId, divisionFieldId, divisions, facility }) => {
      if (unitFieldId) {
        this.unitFieldId = unitFieldId;
      }
      if (divisionFieldId) {
        this.divisionFieldId = divisionFieldId;
      }
      if (divisions) {
        this.divisions = divisions;
      }
      if (facility) {
        this.userForm.patchValue({
          facility: facility,
        });
      }
      this.isLoading = false;
    });

    this.userForm = this.fb.group({
      facility: [""],
      division: ["-1"],
      unit: ["-1"],
    });
  }

  nextStep() {
    this.validationMessages = this.userService.validateNewErtUserStep1(
      this.userForm
    );
    if (this.validationMessages.length > 0) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    this.validationMessages = [];
    if (this.userForm.valid) {
      this.userService.setERTUser(<ERTUser>{
        facility: null,
        divisionId: this.selectedDivision.id,
        division: this.selectedDivision.value,
        unitId: this.selectedUnit.id,
        unit: this.selectedUnit.value,
      });
      this.router.navigateByUrl("/ert-user/ert-new-user-details");
    }
  }

  onUnitSelected(unit: IPicklistValuesData): void {
    this.selectedUnit = unit;
  }

  onDivisionSelected(division: IPicklistValuesData): void {
    this.selectedDivision = division;
    this.selectedUnit = null;
    this.userForm.get("unit").setValue("-1");
  }
}
